export const ADMIN_TYPES = [
  { ValueText1: "Süper Admin", Code: "super_admin" },
  { ValueText1: "Admin", Code: "admin" }
];

export const STATE_COLOR = {
  open: 'default',
  approved: 'success',
  rejected: 'error',
  cancelled: 'warning',
};

export const TIER_TYPES = [
  { ValueText1: "Basic", Code: 1 },
  { ValueText1: "Standard", Code: 2 },
  { ValueText1: "Advanced", Code: 3 },
  { ValueText1: "Elite", Code: 4 }
];

export const BOOST_CATEGORY_TYPES = [
  { ValueText1: "Weekly", Code: "weekly" },
  { ValueText1: "Special Offer", Code: "special_offer" },
  { ValueText1: "Period", Code: "period" },
];

export const BOOST_CATEGORIES = [
  {
    Code: "BACK_TO_MARKET",
    ValueText1: "Back To Market Program"
  },
  {
    Code: "TREND_INSTRUMENT",
    ValueText1: "Trending Instrument"
  },
  {
    Code: "ONSA_TRIO",
    ValueText1: "Onsa Trio"
  },
  {
    Code: "MULTI_TRADE",
    ValueText1: "Multi-Trade"
  },
  {
    Code: "DIVIDEND",
    ValueText1: "Dividend"
  },
  {
    Code: "ONSA_ACADEMY",
    ValueText1: "Onsa Academy"
  },
  {
    Code: "CHECK_UP",
    ValueText1: "Check-Up"
  },
  {
    Code: "TRADE_INSURANCE",
    ValueText1: "Trade Insurance"
  },
  {
    Code: "ONSA_MARKET",
    ValueText1: "Onsa Market"
  },
  {
    Code: "FLASH_CREDIT",
    ValueText1: "Flash Credit"
  },
  {
    Code: "EXCHANGE",
    ValueText1: "Ex-Change"
  },
  {
    Code: "SOLID_STEP",
    ValueText1: "Solid Step"
  },
  {
    Code: "FIX_TRADE",
    ValueText1: "Fix Trade"
  },
  {
    Code: "ONSA_CREDIT",
    ValueText1: "Onsa Credit"
  }
];

export const TICKET_STATE_TYPES = [
  { ValueText1: "Open", Code: "open" },
  { ValueText1: "Approved", Code: "approved" },
  { ValueText1: "Rejected", Code: "rejected" },
  { ValueText1: "Closed", Code: "closed" },
  { ValueText1: "Completed", Code: "completed" }
];

export const BOOST_STATE_TYPES = [
  { ValueText1: "Active", Code: "active" },
  { ValueText1: "Inactive", Code: "inactive" },
  { ValueText1: "Expired", Code: "expired" },
];

export const LIMIT_TYPES = [
  { ValueText1: "Tutar ($)", Code: "AMOUNT" },
  { ValueText1: "Yüzde (%)", Code: "PERCENT" },
];
